import React, { forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Container from './Container';
import Text from './Text';

const StyledLabel = styled.label`
  z-index: 1;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  cursor: pointer;
`;

const StyledInput = styled.input`
  display: none;
`;

const FileUpload = forwardRef(
  (
    {
      onSelected,
      children,
      value,
      multiple,
      accept,
      dragOverClassName,
      ...props
    },
    ref
  ) => {
    const containerRef = useRef();

    const onDrop = e => {
      e.preventDefault();
      onSelected(e.dataTransfer.files);
      containerRef.current.classList.remove(dragOverClassName);
    };

    const onDragOver = e => {
      e.preventDefault();
      containerRef.current.classList.add(dragOverClassName);
    };

    const onDragLeave = e => {
      e.preventDefault();
      containerRef.current.classList.remove(dragOverClassName);
    };

    const onChange = e => {
      e.preventDefault();
      onSelected(e.target.files);
    };

    return (
      <Container
        ref={containerRef}
        position="relative"
        backgroundColor="background100"
        {...props}
      >
        {children || <Text>Click to choose a file or drag it here</Text>}
        <StyledLabel
          onDrop={onDrop}
          onDragOver={onDragOver}
          onDragLeave={onDragLeave}
        >
          <StyledInput
            ref={ref}
            value={value}
            type="file"
            onChange={onChange}
            multiple={multiple}
            accept={accept}
          />
        </StyledLabel>
      </Container>
    );
  }
);

FileUpload.propTypes = {
  onSelected: PropTypes.func.isRequired,
  children: PropTypes.node,
  value: PropTypes.string,
  multiple: PropTypes.bool,
  accept: PropTypes.string,
  dragOverClassName: PropTypes.string,
};

FileUpload.defaultProps = {
  children: null,
  value: '',
  multiple: false,
  accept: '',
  dragOverClassName: 'drag-over',
};

export default FileUpload;
